document.addEventListener("DOMContentLoaded", () => {
  const socialLinks = document.querySelectorAll(".social-link");
  const dropdown = document.querySelector(".main_center-menu .dropdown");
  const dropdownItems = dropdown.querySelectorAll("li:not(.content li)");
  const contentContainer = dropdown.querySelector(".content-container");
  const headerLinks = document.querySelectorAll(".header-links");
  const menuLinks = document.querySelectorAll(
    ".main_center-menu .dropdown .content li a, .sliding-menu .depth-sub-menu-children li a"
  );
  let hoverTimeout;

  socialLinks.forEach((link, index) => {
    link.addEventListener("mouseenter", () => {
      clearTimeout(hoverTimeout);

      hoverTimeout = setTimeout(() => {
        const group = link.getAttribute("data-dropdown");
        dropdown.classList.remove(
          ...Array.from(dropdown.classList).filter((c) =>
            c.startsWith("index-sl-")
          )
        );

        dropdown.classList.add(`index-sl-${index + 1}`);
        dropdown.style.display = "flex";

        contentContainer.className = `content-container s-${group}`;

        dropdownItems.forEach((item) => {
          if (item.getAttribute("data-group") === group) {
            item.classList.add("active");
          } else {
            item.classList.remove("active");
          }
        });

        contentContainer.querySelectorAll(".content").forEach((content) => {
          content.classList.remove("active");
        });

        const firstItem = dropdown.querySelector("li.active");
        if (firstItem) {
          dropdownItems.forEach((item) => item.classList.remove("selected"));
          firstItem.classList.add("selected");

          const targetId = firstItem.getAttribute("data-content");
          const groupId = firstItem.getAttribute("data-group");

          // Find the element that matches both data-content and data-group
          const targetElement = document.querySelector(
            `[id="${targetId}"][data-group="${groupId}"]`
          );

          if (targetElement) {
            targetElement.classList.add("active");
          }
        }
      }, 120);
    });

    link.addEventListener("mouseleave", () => {
      clearTimeout(hoverTimeout);
    });
  });

  document.body.addEventListener("mousemove", (event) => {
    if (
      !dropdown.contains(event.target) &&
      !Array.from(socialLinks).some((link) => link.contains(event.target)) &&
      !Array.from(headerLinks).some((link) => link.contains(event.target))
    ) {
      dropdown.style.display = "none";
    }
  });
  // Delegate click event for dropdown items
  dropdownItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      clearTimeout(hoverTimeout);

      hoverTimeout = setTimeout(() => {
        // Remove 'selected' class from all dropdown items
        dropdownItems.forEach((item) => item.classList.remove("selected"));
        item.classList.add("selected");

        // Remove 'active' class from all content elements
        contentContainer.querySelectorAll(".content").forEach((content) => {
          content.classList.remove("active");
        });

        const contentId = item.getAttribute("data-content");
        const groupId = item.getAttribute("data-group");

        // Find the element that matches both data-content and data-group
        const targetElement = document.querySelector(
          `[id="${contentId}"][data-group="${groupId}"]`
        );

        if (targetElement) {
          targetElement.classList.add("active");
        }
      }, 140);
    });
    item.addEventListener("mouseleave", () => {
      clearTimeout(hoverTimeout);
    });
  });

  document.addEventListener("click", (e) => {
    if (!e.target.closest(".social-link") && !e.target.closest(".dropdown")) {
      dropdown.style.display = "none";
    }
  });

  const closeBtn = document.querySelector(".dropdown-close-btn");
  closeBtn.addEventListener("click", () => {
    dropdown.style.display = "none";
  });

  const menuTrigger = document.querySelector(".menu-trigger");
  const promoTrigger = document.querySelector(".js-promo-open-menu");
  const iconMenu = document.querySelector(".icon-menu");
  const menuContainer = document.getElementById("menuContainer");
  const submenuContainer = document.getElementById("submenuContainer");
  const backButton = document.getElementById("backButton");
  const menuItems = document.querySelectorAll(".sliding-menu .menu > li");
  const submenus = document.querySelectorAll(".sliding-menu .submenu");
  const subMenuTitles = document.querySelectorAll(
    ".sliding-menu .depth-sub-menu-title"
  );
  const menuOverlay = document.querySelector(".sliding-overlay");
  const slidingMenu = document.querySelector(".sliding-menu");

  const toggleMenu = (event) => {
    event.stopPropagation();
    menuContainer.classList.toggle("active");
    menuOverlay.classList.toggle("active");
    document.body.classList.toggle("modal-open");
  };

  document.addEventListener("click", (event) => {
    if (!slidingMenu.contains(event.target)) {
      menuContainer.classList.remove("active");
      menuOverlay.classList.remove("active");
      submenuContainer.classList.remove("active");
      document.body.classList.remove("modal-open");
    }
  });

  menuTrigger.addEventListener("click", toggleMenu);
  iconMenu.addEventListener("click", toggleMenu);
  if (promoTrigger) {
    promoTrigger.addEventListener("click", toggleMenu);
  }

  const directRedirect = ["itunes-top-100", "apple-music", "buy-apple-music-streams"];

  menuItems.forEach((item) => {
    item.addEventListener("click", () => {
      const submenuId = item.getAttribute("data-submenu");

      if (submenuId) {
        if (directRedirect.includes(submenuId)) {
          const submenu = document.getElementById(submenuId);
          const link = submenu?.querySelector("a.view-all-link");
          if (link) {
            window.location.href = link.href;
          }
          return;
        }

        submenus.forEach((submenu) => {
          submenu.classList.remove("active");
        });

        const submenu = document.getElementById(submenuId);
        if (submenu) {
          submenu.classList.add("active");
          submenuContainer.classList.add("active");
          backButton.classList.add(`submenu-${submenuId}`);
        }
      }
    });
  });

  backButton.addEventListener("click", () => {
    submenuContainer.classList.remove("active");
    backButton.className = backButton.className
      .split(" ")
      .filter((className) => !className.startsWith("submenu-"))
      .join(" ");
  });

  subMenuTitles.forEach((title) => {
    title.addEventListener("click", function () {
      const parent = title.closest(".depth-sub-menu");
      parent.classList.toggle("open");
    });
  });

  document
    .getElementById("searchInput")
    .addEventListener("input", function (event) {
      let searchTerm = event.target.value.toLowerCase();
      let menuItems = document.querySelectorAll(".sliding-menu .primary-item");

      menuItems.forEach(function (item) {
        let title = item.textContent.toLowerCase();
        if (title.indexOf(searchTerm) > -1) {
          item.style.display = "flex";
        } else {
          item.style.display = "none";
        }
      });
    });

  document.getElementById("closeButton").addEventListener("click", function () {
    submenuContainer.classList.remove("active");
    backButton.className = backButton.className
      .split(" ")
      .filter((className) => !className.startsWith("submenu-"))
      .join(" ");
    menuContainer.classList.toggle("active");
    menuOverlay.classList.remove("active");
    document.body.classList.remove("modal-open");
  });

  document.querySelector(".c-dropdown__toggler").addEventListener("click", function (e) {
    document.querySelector(".c-dropdown__body").classList.toggle("active");
  });

  document.addEventListener("click", function (e) {
    if (!document.querySelector(".c-dropdown__body").contains(e.target) &&
      !document.querySelector(".c-dropdown__toggler").contains(e.target)) {
      document.querySelector(".c-dropdown__body").classList.remove("active");
    }
  });

  document.addEventListener("click", function (event) {
    const isInsideMenu =
      submenuContainer.contains(event.target) ||
      menuContainer.contains(event.target) ||
      menuTrigger.contains(event.target) ||
      (promoTrigger && promoTrigger.contains(event.target)) ||
      iconMenu.contains(event.target);

    const isSubmenuItem = event.target.closest(
      ".sliding-menu .depth-sub-menu-children li"
    );

    if (!isInsideMenu || isSubmenuItem) {
      submenuContainer.classList.remove("active");
      backButton.className = backButton.className
        .split(" ")
        .filter((className) => !className.startsWith("submenu-"))
        .join(" ");
      menuContainer.classList.remove("active");
      menuOverlay.classList.remove("active");
      document.body.classList.remove("modal-open");
    }
  });

  document.querySelectorAll(".show-more-btn").forEach((btn) => {
    btn.addEventListener("click", function () {
      var gridWrapper = this.closest(".tag-products-grid").querySelector(".product-grid-wrapper");

      if (gridWrapper) {
        gridWrapper.classList.toggle("expanded");
        this.querySelector("svg").classList.toggle("rotated");
      }
    });
  });

  document.addEventListener("click", function (event) {
    const allVariantsLists = document.querySelectorAll(".product-variants-list");
    const clickedToggle = event.target.closest(".toggle-variants");
    const clickedProduct = event.target.closest(".item-product");

    if (clickedToggle) {
      const itemProduct = clickedToggle.closest(".item-product");
      const variantsList = itemProduct.querySelector(".product-variants-list");

      if (variantsList) {
        const isOpen = variantsList.classList.contains("show");

        allVariantsLists.forEach(list => {
          list.classList.remove("show");

          const swiperContainer = list.closest(".swiper-container");
          if (swiperContainer) {
            const prevBtn = swiperContainer.querySelector(".swiper-button-prev");
            const nextBtn = swiperContainer.querySelector(".swiper-button-next");
            if (prevBtn) prevBtn.style.display = "";
            if (nextBtn) nextBtn.style.display = "";
          }
        });

        if (!isOpen) {
          variantsList.classList.add("show");

          const swiperContainer = itemProduct.closest(".swiper-container");
          if (swiperContainer) {
            const prevBtn = swiperContainer.querySelector(".swiper-button-prev");
            const nextBtn = swiperContainer.querySelector(".swiper-button-next");
            if (prevBtn) prevBtn.style.display = "none";
            if (nextBtn) nextBtn.style.display = "none";
          }
        }
      }
    } else {
      if (!clickedProduct) {
        allVariantsLists.forEach(list => {
          list.classList.remove("show");

          const swiperContainer = list.closest(".swiper-container");
          if (swiperContainer) {
            const prevBtn = swiperContainer.querySelector(".swiper-button-prev");
            const nextBtn = swiperContainer.querySelector(".swiper-button-next");
            if (prevBtn) prevBtn.style.display = "";
            if (nextBtn) nextBtn.style.display = "";
          }
        });
      }
    }
  });



  const faqItems = document.querySelectorAll('.faq-item');

  faqItems.forEach(function (faqItem) {
    faqItem.addEventListener('click', function () {
      faqItem.classList.toggle('active');
    });
  });

  function numberWithCommas(x) {
    return x.replace(/\d+/g, function (match) {
      return match.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    });
  }

  var productCountElements = document.querySelectorAll('.count-num');

  productCountElements.forEach(function (element) {
    var text = element.textContent.trim();
    var updatedText = numberWithCommas(text);
    element.textContent = updatedText;
  });


});


document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener('scroll', function () {
    const button = document.getElementById('back2Top');
    if (window.scrollY > 300) {
      button.style.display = 'block';
    } else {
      button.style.display = 'none';
    }
  });
  document.getElementById('back2Top').addEventListener('click', function () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const isProduct = window.location.pathname.includes('/products/')
  const hasChatParam = window.location.search.includes('chat')

  if (!isProduct || hasChatParam) return

  document.body.classList.add('chat-hidden-tag')

  window.addEventListener('scroll', () => {
    if (window.scrollY > 300) {
      document.body.classList.remove('chat-hidden-tag')
    } else {
      document.body.classList.add('chat-hidden-tag')
    }
  })
});